module.exports = __webpack_public_path__ + "static/media/testing.90294d44.jpg";